import React, { useState } from "react";
import "./Request.css";

type RequestErrorProps = {
  resource: string;
  action: string;
  loading: boolean;
  err: any | null;
};

const Request: React.FC<RequestErrorProps> = ({
  resource,
  action,
  loading,
  err,
  children,
}) => {
  const [showDetails, setShowDetails] = useState(false);

  function fix(s: string): string {
    s = s.replace("de el", "del");
    return s[0].toUpperCase() + s.slice(1);
  }

  function replaceNewlines(s: string) {
    return (
      <>
        {s.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </>
    );
  }

  function simple(message: string) {
    return (
      <div className="request-error">
        <div className="request-error-summary">
          <p>{replaceNewlines(fix(message))}</p>
        </div>
      </div>
    );
  }

  function detailed(message: string) {
    return (
      <div className="request-error">
        <div className="request-error-summary">
          <p>{replaceNewlines(fix(message))}</p>

          {!showDetails && (
            <button onClick={() => setShowDetails(true)}>
              Mostrar detalles
            </button>
          )}
        </div>

        {showDetails && (
          <div>
            <pre>{JSON.stringify(err, null, "  ")}</pre>
            {err.stack && <pre>{err.stack}</pre>}
          </div>
        )}
      </div>
    );
  }

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (!err) {
    return <>{children}</>;
  }

  return null;
};

export default Request;
